import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router/index'
import QRcode from './components/QRCode/index'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from "axios"; // 安装axios后引入
import watermark from "@/assets/js/waterMark.js"





const app = createApp(App)
app.directive('w-watermark', (el, binding) => {
    watermark({
        text:binding.value.label,
        textColor:"rgba(219,219,219,0.41)",
        backgroundColor:"#F5F6F7",
    },el)
})
app.config.globalProperties.$axios = axios; // 将axios挂载到原型上方便使用
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(QRcode);
app.use(router);
app.use(ElementPlus,{locale})
app.mount('#app')
